export default function location( el ) {
	if ( ! el ) {
		return;
	}
	const slider = el.querySelector( '.b-location-items' );
	if ( slider ) {
		const flkty = new Flickity( slider, {
			cellAlign: 'left',
			pageDots: false,
			contain: true,
			prevNextButtons: false, // Disable default prev/next buttons
		} );

		// Custom previous button
		const prevButton = el.querySelector( '.b-location-prev' );
		if ( prevButton ) {
			prevButton.addEventListener( 'click', function() {
				flkty.previous();
			} );
		}

		// Custom next button
		const nextButton = el.querySelector( '.b-location-next' );
		if ( nextButton ) {
			nextButton.addEventListener( 'click', function() {
				flkty.next();
			} );
		}

		// Function to equalize slide heights
		const equalizeSlideHeights = () => {
			const slideItems = slider.querySelectorAll( '.b-location-slide' );
			let maxHeight = 0;

			// Reset heights first
			slideItems.forEach( ( item ) => {
				item.style.height = '';
				const itemHeight = item.offsetHeight;
				maxHeight = Math.max( maxHeight, itemHeight );
			} );

			// Set all slides to the max height
			slideItems.forEach( ( item ) => {
				item.style.height = maxHeight + 'px';
			} );
		};

		equalizeSlideHeights();

		// Equalize heights after Flickity is initialized
		flkty.on( 'ready', equalizeSlideHeights );

		// Re-equalize on window resize
		window.addEventListener( 'resize', () => {
			equalizeSlideHeights();
			flkty.resize(); // Make sure Flickity updates its layout
		} );
	}
}
